import { getField, updateField, createHelpers } from "vuex-map-fields";

import {
  SUCCESS,
  ERROR,
  RESET_STATE,
  UPDATE_USER_DRAWER,
  UPDATE_DRAWER,
  DROP_SNACKBAR,
  SET_DESTINATION_ROUTERNAME,
  SET_DESTINATION_ROUTERPARAMS
} from "@/store/mutation-types";
import {
  TOGGLE_USER_DRAWER,
  TOGGLE_DRAWER,
  ADD_SNACKBAR,
  HIDE_SNACKBAR,
  SET_DESTINATION
} from "@/store/action-types";

const getDefaultState = () => ({
  isUserDrawerOpen: false,
  isCompanyDrawerOpen: false,
  snackbar: false,
  snackbarMessage: "",
  snackbarType: "info",
  snackbarTimeout: 6000,
  destinationRouterName: null,
  destinationRouterParams: null
});

const state = getDefaultState();

const getters = {
  getField,
  destinationRouterName: state => state.destinationRouterName,
  destinationRouterParams: state => state.destinationRouterParams
};

const mutations = {
  updateField,
  [UPDATE_USER_DRAWER](state, { toggle } = {}) {
    state.isUserDrawerOpen = toggle || !state.isUserDrawerOpen;
  },
  [UPDATE_DRAWER](state, { drawerName = "", toggle } = {}) {
    if (state[`is${drawerName}DrawerOpen`] !== undefined) {
      state[`is${drawerName}DrawerOpen`] =
        toggle || !state[`is${drawerName}DrawerOpen`];
    }
  },
  [SUCCESS](state, { message = false, type = "success", timeout = 6000 } = {}) {
    if (state.snackbar && state.snackbarType == "success") {
      message = `${state.snackbarMessage}<br/>${message}`;
    }

    state.snackbar = true;
    state.snackbarType = type;
    state.snackbarMessage = message;
    state.snackbarTimeout = timeout;
  },
  [DROP_SNACKBAR](state, { message = "" } = {}) {
    state.message = message;
    state.snackbar = false;
  },
  [ERROR](
    state,
    {
      error = {},
      message = "Une erreur est survenue, veuillez essayer à nouveau dans quelques instants.",
      timeout = 6000
    } = {}
  ) {
    state.snackbar = true;
    state.snackbarType = "error";
    state.snackbarTimeout = timeout;
    if (error.response && error.response.status == "401") {
      state.snackbarMessage = "Veuillez vous reconnecter.";
    } else {
      state.snackbarMessage = message;
    }
  },
  [RESET_STATE](state) {
    let destinationRouterNameCache = state.destinationRouterName;
    let destinationRouterParamsCache = state.destinationRouterParams;
    Object.assign(state, getDefaultState());
    state.destinationRouterName = destinationRouterNameCache;
    state.destinationRouterParams = destinationRouterParamsCache;
  },
  [SET_DESTINATION_ROUTERNAME](state, { routerName }) {
    state.destinationRouterName = routerName;
  },
  [SET_DESTINATION_ROUTERPARAMS](state, { routerParams }) {
    state.destinationRouterParams = routerParams;
  }
};

const actions = {
  [TOGGLE_USER_DRAWER]({ commit }, { toggle } = {}) {
    commit(UPDATE_USER_DRAWER, { toggle });
  },
  [TOGGLE_DRAWER]({ commit }, { drawerName, toggle } = {}) {
    drawerName = drawerName.charAt(0).toUpperCase() + drawerName.slice(1);
    commit(UPDATE_DRAWER, { drawerName: drawerName, toggle });
  },
  [ADD_SNACKBAR]({ commit }, { message, type, timeout } = {}) {
    commit(SUCCESS, { message, type, timeout });
  },
  [HIDE_SNACKBAR]({ commit }, { message } = {}) {
    commit(DROP_SNACKBAR, { message });
  },
  [SET_DESTINATION]({ commit }, { routerName, routerParams }) {
    commit(SET_DESTINATION_ROUTERNAME, {
      routerName
    });
    commit(SET_DESTINATION_ROUTERPARAMS, {
      routerParams
    });
  }
};

export const { mapFields: mapAppFields } = createHelpers({
  getterType: `app/getField`,
  mutationType: `app/updateField`
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
